import React from "react"
import SbEditable from "storyblok-react"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components//atoms/Image"
import Headline from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Headline"
import HeadlineEnhanced from "../molecules/HeadlineEnhanced"

const NewsHeader = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="pb-8 ">
        <div className="relative bg-gray-800 h-[34vh] md:h-[31rem] overflow-hidden">
          {block.image?.filename?.length > 0 && (
            <Image
              image={block.image}
              className="block object-cover w-full h-full"
            />
          )}
          {block?.show_square && (
            <div className="absolute top-0 right-0 block w-24 h-24 bg-primary"></div>
          )}
          <div className="absolute inset-0 z-20">
            <div className="relative h-full max-w-screen-xl mx-auto text-white px-grid bg-gradient-to-r from-gray-800 via-transparent">
              <div className="absolute z-30 block w-1/2 h-full bg-gray-800 right-full"></div>
              <div className="flex flex-col justify-center h-full">
                <div className="w-full pr-4 md:w-1/2">
                  <HeadlineEnhanced
                    kickerClass="text-primary"
                    kicker={block.kicker}
                    headlineClass="text-white"
                    headline={block.headline}
                    headlineLevel="h1"
                    tagName="h1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default NewsHeader
